let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
if (document.querySelectorAll('.add-to-wishlist').length > 0) {
  document.querySelectorAll('.add-to-wishlist').forEach(function (wishlistButton) {
    wishlistButton.addEventListener('click', function () {
      let productData = {
        id: this.getAttribute('data-product-id'),
        name: this.getAttribute('data-product-name'),
        price: this.getAttribute('data-product-price'),
        imageUrl: this.getAttribute('data-product-image'),
        url: this.getAttribute('data-product-url')
      };

      let isProductInWishlist = wishlist.some(item => item.id === productData.id);

      if (!isProductInWishlist) {
        wishlist.push(productData);
        localStorage.setItem('wishlist', JSON.stringify(wishlist));

        // Update the wishlist popup content
        updateWishlistPopup(wishlist);

        // Show the popup
        document.getElementById('wishlist-popup').style.display = 'flex';
      } else {
        alert('This product is already in your wishlist.');
      }
    });
  });
}

// Function to update wishlist popup
function updateWishlistPopup(wishlist) {
  let wishlistItems = document.getElementById('wishlist-items');
  wishlistItems.innerHTML = ''; // Clear previous content

  wishlist.forEach(function (product) {
    let listItem = document.createElement('li');
    listItem.innerHTML = `<div class="product-item">
                            <img src="${product.imageUrl}" alt="${product.name}" style="width: 100px; height: 100px;"><br>
                            <a href="${product.url}" target="_blank">${product.name}</a><br> 
                            <span class="price">${product.price}</span>
                 
                          </div>`;
    wishlistItems.appendChild(listItem);
  });
}

// Close button for wishlist popup
document.getElementById('close-wishlist-popup').addEventListener('click', function () {
  document.getElementById('wishlist-popup').style.display = 'none';
});


// // Check if there is any item in the wishlist
if (wishlist.length > 0) {
  let wishlistItems = document.getElementById('wishlist-items');
  wishlistItems.innerHTML = '';
  // Get the last product in the wishlist
  let lastProduct = wishlist[wishlist.length - 1];

  wishlist.forEach(function (product) {
    let listItem = document.createElement('li');
    listItem.innerHTML = `<div class="product-item">
                            <div class="image-wrap">
                              <img src="${product.imageUrl}" alt="${product.name}" style="width: 100px; height: 100px;">
                            </div>
                            <div class="content-wrap">
                              <a href="${product.url}" target="_blank">${product.name}</a>
                              <span class="price">${product.price}</span>
                            </div>
                          </div>`;
    wishlistItems.appendChild(listItem);
  });

  // Access the image property of the last product
  let lastImage = lastProduct.imageUrl;

  document.getElementById('recently-added').innerHTML = `<img src="${lastImage}" alt="Recently Added Product" id="recently-added-img">`;
  document.getElementById('recently-added').style.display = 'flex';

} else {
  document.getElementById('recently-added').innerHTML = '';
  document.getElementById('recently-added').style.display = 'none';
}


document.getElementById('recently-added').addEventListener('click', function () {
  document.getElementById('wishlist-popup').style.display = 'flex';
});